import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { UserConnectionResponse } from '../../types/Types';

interface useGetSentConnectionRequestsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetSentConnectionRequests({ userId, enabled = true }: useGetSentConnectionRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ['sentconnectionrequests', userId],
    queryFn: async () => {
      return axiosInstance<UserConnectionResponse>(getAPIURL(`/User/sentconnectionrequests/${userId}/`)).then(
        (response) => response.data,
      );
    },
  });
}